import { Observable } from 'rxjs';
import Axios from 'axios-observable';

const Domain = process.env.REACT_APP_MAIN_API_SERVER;

class Regulators {
    get() {
        return new Observable(subscriber => {
            Axios.get(Domain + '/regulator-selector/').subscribe(resp => {
                subscriber.next(resp.data.regulators);
                subscriber.complete();
            });
        })
    }
}
export default new Regulators();